import * as pdfjs from 'pdfjs-dist/legacy/build/pdf.mjs';

// Use CDN worker — avoids needing webpack/CRA to bundle the worker file.
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;

const MAX_CHARS = 200_000;

export async function extractPdfText(file) {
  const buf = await file.arrayBuffer();
  const pdf = await pdfjs.getDocument({ data: buf }).promise;
  const parts = [];
  let total = 0;
  for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
    const page = await pdf.getPage(pageNum);
    const content = await page.getTextContent();
    const pageText = content.items.map((i) => ('str' in i ? i.str : '')).join(' ');
    parts.push(pageText);
    total += pageText.length;
    if (total > MAX_CHARS) break;
  }
  let text = parts.join('\n\n').replace(/\s+/g, ' ').trim();
  if (text.length > MAX_CHARS) text = text.slice(0, MAX_CHARS) + '\n[...truncated]';
  return { text, pages: pdf.numPages };
}
